import { render } from "./GeoComuni.vue?vue&type=template&id=3ab3866e&scoped=true"
import script from "./GeoComuni.vue?vue&type=script&lang=js"
export * from "./GeoComuni.vue?vue&type=script&lang=js"

import "./GeoComuni.vue?vue&type=style&index=0&id=3ab3866e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab3866e"]])

export default __exports__